<template>
    <i 
        :id="id" 
        class="pi pi-asterisk c-required-marker" 
        :style="style"
    ></i>
</template>
<script setup>
    import { sleep } from '@/composables/sleep';
    import { geenrateUUID } from '@/composables/uuidHandler';
    import { ref, defineProps, onMounted, watch } from 'vue';

    const props = defineProps({
        isValid: {
            type: Boolean,
            default: true
        },
        id: {
            type: String,
            default: null
        }
    })

    let id = ref();
    let isValid = ref();
    let style = ref();
    onMounted(() => {
        isValid.value = props.isValid;
        setId();
        getStyle();
    })

    watch(() => props.isValid, (newValue) => {
        isValid.value = newValue;
        getStyle();
    },
        { deep: true }
    );

    async function setId(){
        if(props.id == null){
            await sleep(1);
            id.value = geenrateUUID()
        }else{
            id.value = props.id;
        }
    }

    async function getStyle(){
        await sleep(1);
        let styleList = {
            'font-size': '0.8em',
            'color': ''
        }
        styleList['color'] = isValid.value ? '' : 'red';
        style.value = styleList;
    }
</script>